export const getDesgCotid = (id,hash) => {
  return new Promise((resolve, reject) => {
    const myHeaders = new Headers();
    var formdata = new FormData();
    myHeaders.append("Authorization", `Bearer ${localStorage.getItem("ContaKMPCot")}`)
    formdata.append("id", id);
    formdata.append("hash", hash);
    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: formdata,
      redirect: 'follow'
    };

    fetch(`https://conta-api.solucioneskmp.com/CotizacionesUser/getDesgloceidCot`, requestOptions)
      .then(response => response.json())
      .then(result => resolve(result))
      .catch(error => reject(error));
  })
}